const renderElements = ({ element, values, handleChange, setValues, handleBlur }) => {
  switch (element?.type) {
    case 1:
      return (
        <div className='form-group'>
          <label>
            {element?.label}
            {element?.required && '*'}
          </label>

          <div className='d-flex'>
            {element?.pretend && (
              <div class='input-group-prepend'>
                <span class='input-group-text' style={{ minHeight: '100%' }} id='basic-addon1'>
                  {element?.pretend}
                </span>
              </div>
            )}
            <input
              className='form-field'
              type={element?.inputType ?? 'text'}
              name={element?.name}
              value={values?.[element?.name] ?? ''}
              onChange={handleChange}
              required={element?.required ?? false}
              disabled={element?.disabled ?? false}
              onBlur={() => handleBlur && handleBlur()}
              placeholder={element?.placeholder}
            />
          </div>
        </div>
      );

    case 2:
      return (
        <div className='form-group'>
          <label>
            {element?.label}
            {element?.required && '*'}
          </label>

          <div className='d-flex'>
            {element?.pretend && (
              <div class='input-group-prepend'>
                <span class='input-group-text' style={{ minHeight: '100%' }} id='basic-addon1'>
                  {element?.pretend}
                </span>
              </div>
            )}
            <textarea
              className='form-field'
              type={element?.inputType ?? 'text'}
              name={element?.name}
              value={values?.[element?.name] ?? ''}
              onChange={handleChange}
              required={element?.required ?? false}
              disabled={element?.disabled ?? false}
              onBlur={() => handleBlur && handleBlur()}
              placeholder={element?.placeholder ?? ''}
            />
          </div>
        </div>
      );

    default:
      break;
  }
};

export default renderElements;
